var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import palette from './palette';
import * as styledComponents from './styled';
var injectGlobal = styledComponents.injectGlobal, styled = styledComponents.default;
var theme = {
    datashop: {
        palette: palette,
        weights: {
            thin: 400,
            regular: 400,
            semibold: 600,
            bold: 700,
            strong: 800,
        },
        _htmlFontSize: 10,
        baseFontSize: 1.4,
    },
};
export default theme;
export { theme, styledComponents };
export var globalCSS = function () { return injectGlobal(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n  @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700;800');\n  @import url('https://fonts.googleapis.com/icon?family=Material+Icons');\n"], ["\n\n  @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700;800');\n  @import url('https://fonts.googleapis.com/icon?family=Material+Icons');\n"]))); };
export var GlobalStyleProvider = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  > * {\n    box-sizing: border-box;\n    font-size: 14px;\n    font-family: 'Nunito Sans', 'Roboto', 'Source Sans Pro', 'Helvetica Neue',\n      Helvetica, Roboto, Arial, sans-serif;\n    font-weight: 400;\n    -webkit-font-smoothing: antialiased;\n  }\n"], ["\n  > * {\n    box-sizing: border-box;\n    font-size: 14px;\n    font-family: 'Nunito Sans', 'Roboto', 'Source Sans Pro', 'Helvetica Neue',\n      Helvetica, Roboto, Arial, sans-serif;\n    font-weight: 400;\n    -webkit-font-smoothing: antialiased;\n  }\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map